import { History } from "history";
import { createContext } from "react";

export interface RouterContextType {
  history: History;
  path: string;
  query: string;
  queryParams: {
    [key: string]: string;
  };
}

const RouterContext = createContext<RouterContextType>({} as RouterContextType);

export default RouterContext;
